import React from 'react'
import { BsFillCheckCircleFill } from 'react-icons/bs'

const AboutLanding = () => {
  return (
    <div className="space-y-20">

      <div className="grid md:grid-cols-2 gap-8 items-center px-4 md:px-0">
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          className="order-1"
        >
          <img
            src="/images/about-1.png"
            alt="Tentang AMS"
            className="w-full max-w-md mx-auto md:max-w-full"
          />
        </div>

        <div
          data-aos="fade-down"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          className="order-2 md:px-12 lg:px-20"
        >
          <h2 className="text-[22px] sm:text-[24px] md:text-[35px] text-[#006c63] mb-4 font-semibold leading-snug md:leading-[50px]">
            Kami Membantu Meningkatkan Bisnis Anda Melalui Teknologi yang Luar Biasa
          </h2>

          <p className="text-[14px] sm:text-[15px] md:text-[16px] text-[#4F5665] leading-7 md:leading-[30px]">
            PT Angkasa Multimedia Solusi adalah perusahaan distribusi perangkat audiovisual
            yang telah berdiri sejak tahun 2022. Didukung oleh tenaga ahli dari berbagai
            disiplin ilmu, kami berkomitmen menghadirkan karya berkualitas serta solusi
            terbaik untuk kebutuhan media promosi digital Anda.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 items-center px-4 md:px-0">
        <div
          data-aos="fade-down"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          className="order-2 md:order-1 md:px-12 lg:px-20"
        >
          <h2 className="text-[22px] sm:text-[24px] md:text-[35px] text-[#006c63] mb-4 font-semibold leading-snug md:leading-[50px]">
            Layanan Profesional Untuk Hasil Maksimal dan Berkelanjutan
          </h2>

          <p className="text-[14px] sm:text-[15px] md:text-[16px] text-[#4F5665] leading-7 md:leading-[30px]">
            Kami memastikan pelanggan merasa aman, nyaman dan mendapatkan dukungan optimal,
            sehingga kami tak hanya menjual produk, namun juga menghadirkan solusi jangka
            panjang.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6 mt-6">
            {[
              "Respon cepat",
              "Anggaran yang Fleksibel",
              "Solusi Terpadu",
              "SLA Berkualitas",
            ].map((item) => (
              <div
                key={item}
                className="flex gap-2 items-center text-[#4F5665]"
              >
                <BsFillCheckCircleFill className="text-[#2FAB73]" size={18} />
                <span className="text-[14px] md:text-[16px]">{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          className="order-1 md:order-2"
        >
          <img
            src="/images/about-3.png"
            alt="Layanan AMS"
            className="w-full max-w-md mx-auto md:max-w-full"
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 items-center px-4 md:px-0">
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          <img
            src="/images/INAPROC-01.png"
            alt="Terdaftar INAPROC"
            className="w-full max-w-md mx-auto md:max-w-full"
          />
        </div>

        <div
          data-aos="fade-down"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          className="md:px-12 lg:px-20"
        >
          <h2 className="text-[22px] sm:text-[24px] md:text-[35px] text-[#006c63] mb-4 font-semibold leading-snug md:leading-[50px]">
            Telah Terdaftar Resmi di Berbagai Platform Nasional
          </h2>

          <p className="text-[14px] sm:text-[15px] md:text-[16px] text-[#4F5665] leading-7 md:leading-[30px]">
            Terdaftar di berbagai platform Nasional seperti LKPP dan INAPROC adalah bukti
            komitmen kami untuk menyediakan produk dan layanan berkualitas bagi pelanggan.
            Hal ini juga membuka peluang partisipasi dalam pengadaan barang dan jasa
            pemerintah serta memperluas jangkauan bisnis kami.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AboutLanding
